"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.demand = void 0;
function demand(condition, code) {
    if (!condition) {
        throw new Error(code);
    }
}
exports.demand = demand;
